<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 产品特点 strat -->
      <el-tab-pane label="产品特点" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Listorder" label="排序" min-width="5%"></el-table-column>
          <el-table-column prop="Pic" label="图标" min-width="70%"></el-table-column>
          <el-table-column prop="Info" label="描述" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 产品特点 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second">
        <el-form :model="addData" ref="addDataRef" label-width="68px">
          <el-form-item label="图标" class="addAdminForm">
            <el-input v-model="addData.pic" placeholder="请输入图标"></el-input>
          </el-form-item>
          <el-form-item label="描述" class="addAdminForm">
            <el-input v-model="addData.info" placeholder="请输入描述"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="three">
        <el-form :model="editData" ref="editDataRef" label-width="68px">
          <el-form-item label="图标" class="addAdminForm">
            <el-input v-model="editData.pic" placeholder="请输入图标"></el-input>
          </el-form-item>
          <el-form-item label="描述" class="addAdminForm">
            <el-input v-model="editData.info" placeholder="请输入描述"></el-input>
          </el-form-item>
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      productid: '',
      addData: {
        pic: '',
        info: ''
      },
      editData: {
        id: '',
        pic: '',
        info: '',
        listorder:''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.productid = row.Id
      this.GetKgjtWebsiteErpProductCharacteristicsNum()
      this.GetKgjtWebsiteErpProductCharacteristicsList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteErpProductCharacteristicsList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.AddKgjtWebsiteErpProductCharacteristics()
    },
    clickEdit (row) {
      this.editData.id = row.Id
      this.editData.pic = row.Pic
      this.editData.info = row.Info
      this.editData.listorder = row.Listorder
      this.activeName = 'three'
    },
    clickDel(row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteErpProductCharacteristics(row)
      })
    },
    clickModify () {
      this.EditKgjtWebsiteErpProductCharacteristics()
    },
    GetKgjtWebsiteErpProductCharacteristicsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductCharacteristicsList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteErpProductCharacteristicsNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductCharacteristicsNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteErpProductCharacteristics: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        pic: that.addData.pic,
        info: that.addData.info
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteErpProductCharacteristics, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteErpProductCharacteristicsNum()
            that.GetKgjtWebsiteErpProductCharacteristicsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteErpProductCharacteristics: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        id: that.editData.id,
        pic: that.editData.pic,
        info: that.editData.info,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteErpProductCharacteristics, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteErpProductCharacteristicsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteErpProductCharacteristics: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteErpProductCharacteristics, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteErpProductCharacteristicsNum()
          that.GetKgjtWebsiteErpProductCharacteristicsList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
